// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.preview.RentalManagerUserListingPreviewWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias } from '../..';

interface GetListingPreviewUrlParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_Path =
  '/api/web/v1/users/properties/preview/getListingPreviewUrl';

/**
 * Get the listing preview URL
 */
export const RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl = (
  getParams: GetListingPreviewUrlParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetListingPreviewUrlParams, never, string>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserListingPreviewWebApiHandler_getListingPreviewUrl_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
